import { render } from "./Berita.vue?vue&type=template&id=0c731d3b"
import script from "./Berita.vue?vue&type=script&lang=js"
export * from "./Berita.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__